module.exports = __webpack_public_path__ + "img/a03.4a08d933.svg";